import { render, staticRenderFns } from "./PC.vue?vue&type=template&id=2ce14f1e&scoped=true&"
import script from "./PC.vue?vue&type=script&lang=js&"
export * from "./PC.vue?vue&type=script&lang=js&"
import style0 from "./PC.vue?vue&type=style&index=0&id=2ce14f1e&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ce14f1e",
  null
  
)

export default component.exports